import React, { Component } from "react";

class ProofWrapper extends Component {
  componentDidUpdate(prevProps) {
    //remove use proof is app/blog/ect.
    if (this.props.location) {
      if (
        this.props.location.pathname.startsWith("/app") ||
        this.props.location.pathname.startsWith("/blog") ||
        this.props.location.pathname.startsWith("/login") ||
        this.props.location.pathname.startsWith("/forgot-password") ||
        this.props.location.pathname.startsWith("/thank-you")
      ) {
        var x = document.getElementsByClassName("proofNotificationWrapper");
        if (x[0]) {
          if (x[0].parentNode) {
            x[0].parentNode.removeChild(x[0]);
          }
        }
      }
    }
  }

  render() {
    return <div />;
  }
}

export default ProofWrapper;
